{
  "worshipSongs": "Chants de louange",
  "playlists": "Listes de lecture",
  "songCount_one": "{{count}} chanson",
  "songCount_many": "{{count}} chansons",
  "songCount_other": "{{count}} chansons"
}
